module.exports = __webpack_public_path__ + "img/mastercard.81542d69.svg";